<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="840"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Form ref="Forms" :model="Forms" :rules="Rules" label-position="top">
                <Row :gutter="32">
                    <Col span="12">
                        <FormItem label="报销模式" prop="mode_id">
                            <RadioGroup v-model="Forms.mode_id" type="button" button-style="solid">
                                <Radio :label="1">普通报销</Radio>
                                <Radio :label="2">项目报销</Radio>
                            </RadioGroup>
                        </FormItem>
                    </Col>
                    <Col span="12" v-if="Forms.mode_id === 2">
                        <FormItem label="报销项目" prop="project_id" :rules="{required: true,type:'number' , message: '请选择报销项目', trigger: 'change',transform(value) { return parseInt(value)}}">
                            <Select v-model="Forms.project_id" clearable filterable  placeholder="报销项目" class="width-100">
                                <Option v-for="(item,index) in projectList" :key="index" :value="item.project_id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="报销金额" prop="money">
                            <Input v-model="Forms.money" type="number" clearable placeholder=""/>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="报销类型" prop="type_id">
                            <Select v-model="Forms.type_id" clearable filterable  placeholder="报销类型" class="width-100">
                                <Option v-for="(item,index) in typeList" :key="index" :value="item.type_id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="申请人" prop="apply_id">
                            <Select v-model="Forms.apply_id" @on-change="getAccount" clearable filterable  placeholder="申请人" class="width-100">
                                <Option v-for="(item,index) in userList" :key="index" :value="item.admin_id">{{item.real_name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="收款账号" prop="account">
                            <Input v-model="Forms.account" clearable placeholder="" class="width-100"/>
                        </FormItem>
                    </Col>
                    <Col span="24">
                      <FormItem label="报销凭证" prop="image" :rules="[{required: true, type:'array', message: '请上传报销凭证', trigger: 'change'}]">
                        <Upload
                            :show-upload-list="false"
                            :action="upload_url"
                            :headers = "{'token': $store.state.token}"
                            :format="['jpg','jpeg','png','gif']"
                            :max-size="10 * 1024"
                            :on-success="handleSuccess"
                            :on-format-error="handleFormatError"
                            :on-exceeded-size="handleMaxSize"
                            :before-upload="handleBeforeUpload">
                          <div class="uploads">
                            <div class="upload-images-icon cursor" v-if="Forms.image.length < 10">
                              <Icon type="md-cloud-upload" size="24" />
                              <span>点击上传</span>
                            </div>
                            <div class="upload-images" v-for="(item,index) in Forms.image" :key="index" @click.stop="">
                              <img :src="site_url + item">
                              <div class="show" @click.stop="PhotoView(site_url + item)">预览</div>
                              <div class="del" @click.stop="PhotoDelete(index)"><Icon type="md-close" /></div>
                            </div>
                          </div>
                        </Upload>
                      </FormItem>
                    </Col>
                </Row>
                <Row :gutter="32">
                    <Col span="24">
                        <FormItem label="备注信息" prop="remark">
                            <Input v-model="Forms.remark" type="textarea" :rows="4" clearable placeholder="备注信息" />
                        </FormItem>
                    </Col>
                </Row>
            </Form>
            <div class="box-drawer-footer">
                <Button class="mr10" @click="FormReset()">取消</Button>
                <Button type="primary" :loading="$store.state.loading" @click="FormSubmit()">保存</Button>
            </div>
        </div>

        <!-- 预览图片 -->
        <Modal
            v-model="is_view_box"
            title="预览"
            :width="840"
            :mask-closable="true"
            :footer-hide="true"
            @on-cancel="PhotoViewClose()">
            <div class="flex-image-box">
                <img :src="view_url" class="flex-image-box-show">
            </div>
        </Modal>

    </Drawer>
</template>

<script>

import {getExpenseConfig, getExpenseDetail, saveExpense} from "@/apis/expense";
import {getAccount} from "@/apis/user";

export default {
    name: 'ExpenseCreate',
    components: {
    },
    emits: ['trueHandler'],
    data () {
        return {
            title : '员工报销',
            isBox : false,
            typeList: [],
            userList: [],
            projectList: [],

            upload_url : this.$uploadApi,
            site_url : this.$siteApi,
            is_view_box : false,
            view_url : '',
            is_select: false,

            Forms : {
                id: '',
                money: '',
                mode_id: 1,
                project_id: '',
                type_id: '',
                image: [],
                account: '',
                apply_id: '',
                remark: ''
            },
            Rules : {
                money: [
                    { required: true, type: 'number',  message: '请输入报销金额', trigger: 'blur',  transform(value) { return parseFloat(value)} }
                ],
                type_id: [
                    { required: true, type: 'number',  message: '请选择报销类型', trigger: 'change',  transform(value) { return parseInt(value)}  }
                ],
                image: [
                    { required: true, type: 'array',  message: '请上传报销凭证', trigger: 'change' }
                ]
            }
        }
    },
    methods: {
      /**
       功能：图片文件
       time: 2025/12/17 10:48
       **/
      FileDelete(f){
        let that = this;
        that.Forms[f] = [];
      },
      /**
       功能：
       time: 2025/12/19 18:12
       **/
      FileDownload(url){
        let that = this;
        if(url){
          //下载文件
          const fileUrl = that.site_url + url; // 文件的URL地址
          const parts = fileUrl.split('/');
          const fileName = parts[parts.length - 1];
          const link = document.createElement('a');
          link.href = fileUrl;
          link.target = '_blank';
          link.setAttribute('download', fileName);
          link.click();
        }else{
          that.$Message.error({ background: true,duration:3, content: '没有资料可下载'});
        }
      },
        /**
         功能：图片预览
         time: 2025-17-15 10:17:00
         **/
        PhotoView(url){
            if(url){
                this.view_url = url;
                this.is_view_box = true;
            }
        },
        /**
         功能：图片删除
         time: 2025/12/15 10:21
         **/
        PhotoDelete(index){
            let that = this;
            that.Forms.image.splice(index , 1);
        },
        /**
         功能：
         time: 2025/12/15 11:16
         **/
        handleSuccess(res){
            let that = this;
            if(res.code === 100){
                that.Forms.image.push(res.data.url);
            }else{
                that.$Message.error({ background: true,duration:3, content: res.msg});
            }
        },
        /**
         功能：
         time: 2025/12/15 11:16
         **/
        handleFormatError(){
            let that = this;
            that.$Message.error({ background: true,duration:3, content: '只支持 jpg | png | gif 文件 ' });
            return false;
        },
        /**
         功能：
         time: 2025/12/15 11:16
         **/
        handleMaxSize(){
            let that = this;
            that.$Message.error({ background: true,duration:3, content: '图片大小不能超出 10M' });
            return false;
        },
        /**
         功能：
         time: 2025/12/15 11:16
         **/
        handleBeforeUpload(){
            let that = this;
            if(that.Forms.image.length >= 10){
                that.$Message.error({ background: true,duration:3, content: '最多只能上传 10 张图' });
                return false;
            }
            return true;
        },
        /**
         功能：
         time: 2025/12/15 11:16
         **/
        PhotoViewClose(){
            this.is_view_box = false;
            this.view_url = '';
        },

        /**
         功能：
         time: 2025/12/25 16:29
         **/
        GetConfig(){
            let that = this;
            getExpenseConfig().then(e=>{
                that.typeList = e.data.typeList ?? [];
                that.userList = e.data.userList ?? [];
                that.projectList = e.data.projectList ?? [];
            })
        },
        getAccount(e){
            let that = this;
            if(e){
                getAccount(e).then(e=>{
                    that.Forms.account = e.data ?? '';
                })
            }else{
                that.Forms.account = '';
            }
        },
        /**
         功能：
         time: 2026/1/6 14:57
         **/
        GetDetail(id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getExpenseDetail(id).then(e => {
                let data = e.data;
                for (let v of Object.keys(that.Forms)) {
                    if(v === 'type_id' || v === 'apply_id') {
                        that.Forms[v] = parseInt(data[v]);
                    }else if(v === 'image') {
                        that.Forms[v] = data[v] ? data[v] : [];
                    }else{
                        that.Forms[v] = data[v];
                    }
                }
            })
        },
        /**
         功能：
         time: 2025/12/25 16:08
         **/
        add(){
            this.isBox = true;
            this.GetConfig();
        },
        /**
         功能：
         time: 2026/1/6 11:47
         **/
        edit(id){
            this.isBox = true;
            this.GetConfig();
            if(id) this.GetDetail(id);
        },
        /**
         功能：
         time: 2025/12/25 17:38
         **/
        FormSubmit(){
            let that = this;
            this.$refs['Forms'].validate((valid) => {
                if (valid) {
                    that.$store.commit('SET_LOADING' , true);
                    saveExpense(that.Forms).then( e =>{
                        that.$Message.success({ background: true,duration:3, content: e.msg });
                        that.FormReset();
                        that.$emit('trueHandler');
                    })
                }
            })
        },
        /**
         功能：
         time: 2025/12/27 10:00
         **/
        FormReset(){
            this.isBox = false;
            this.$refs['Forms'].resetFields();
            this.Forms.typeList = [];
            this.Forms.userList = [];
            this.Forms.id = '';
            this.Forms.project_id = '';
            this.Forms.image = [];
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
.forms {
    .ivu-form-item {
        //margin-bottom: 0 !important;
    }
}
.spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
}
.spin-text {
    font-size: 12px;
    padding-top: 10px;
}
</style>
